import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6795 2.577C13.9058 2.13897 10.0942 2.13897 6.32052 2.577C4.82288 2.75111 3.75 4.0372 3.75 5.507V21C3.75 21.2599 3.88459 21.5013 4.1057 21.638C4.32681 21.7746 4.60292 21.7871 4.83541 21.6708L12 18.0885L19.1646 21.6708C19.3971 21.7871 19.6732 21.7746 19.8943 21.638C20.1154 21.5013 20.25 21.2599 20.25 21V5.507C20.25 4.03691 19.1758 2.75112 17.6795 2.577ZM6.49361 4.06698C10.1522 3.64231 13.8477 3.64231 17.5063 4.06697C18.2099 4.14895 18.75 4.76116 18.75 5.507V19.7865L12.3354 16.5792C12.1243 16.4736 11.8757 16.4736 11.6646 16.5792L5.25 19.7865V5.507C5.25 4.76085 5.78932 4.14893 6.49361 4.06698Z"
        fill={colorValue}
      />
    </svg>
  );
};
